import { User } from "@/models/user";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type InitialState = {
  formType: string,
  users: User[]
}

const initialState: InitialState = {
  formType: "general",
  users: []
}

// async thunk for event check-in


export const adminSlice = createSlice({
  name: "admin",
  initialState: initialState,
  reducers: {
    setFormType: (state, action: PayloadAction<string>) => {
      state.formType = action.payload
    },
    addUsers: (state, action: PayloadAction<User[]>) => {
      const usersToAdd = state.users.filter(user => !state.users.find(u => u.uid === user.uid));
      if (usersToAdd.length > 0) {
        state.users.push(...usersToAdd);
      }
    }
  },
});

export const {
  setFormType,
  addUsers
} = adminSlice.actions;
export default adminSlice.reducer;